export const CARRETA_AGRICOLA_METALICA_HIDRAULICA = {
    Codigo: 4,
    Nome: 'Carreta Agricola Metálica Hidraulica',
    Modelo: 'GIR-1300',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Carreta_Agricola_Matelica_Hidraulica/carreta_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Carreta_Agricola_Matelica_Hidraulica/carreta_1.png"
        }
        , {
            Url: "assets/IPB/Produtos/Carreta_Agricola_Matelica_Hidraulica/carreta_3.png"
        }
    ],
    Detalhes: [
        `Capacidades: 5 e 6 toneladas`,
        `Basculante Hidraulico`,
        `Aros 16/6F`,
        `Eixo Tandem`,
        `Totalmente Desmontável`,
        `Multiuso`
    ],
    Modelos: [
        { Modelo: 'CAH-5000', Detalhes:	'3,03m x 1,80m x 0,95m' },
        { Modelo: 'CAH-6000', Detalhes:	'3,64m x 2,00m x 0,95m' }
    ]
}